const convertStringtoHTML = (string: string | undefined) => {
    if(string === undefined) {
        return(<></>);
    }
    else {
        return <span dangerouslySetInnerHTML={ 
            {
                __html: string
                .replace(/(?:\r\n|\r|\n)/g, '<br>')
                .replace(/\\u[\dA-F]{4}/gi, 
                    function (match) {
                        return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
                    })
            } 
        }/>
    }
}

export default convertStringtoHTML;